import { api } from "./axios.config";
import axios from "./axios";
import React, { useContext } from "react";

const API_URL = api.apiUrl;
const EVENT_URL = "/event/";

export const getPaymentMethodDetails = async (eventId) => {
	const PAYMENT_METHOD = "/payment/methods";
	return axios.get(API_URL + EVENT_URL + eventId + PAYMENT_METHOD);
};

export const getEventPlan = async (eventId, event_plan, pgMethod = 6,) => {
	const QUERY = `?pg_method=${pgMethod}&event_plan=${event_plan}`;
	return axios.get(`${API_URL + EVENT_URL + eventId}/subscribe-event${QUERY}`);
};

export const addPaymentGateway = (eventId, publicKey, secretKey, pgType) => {
    const PAYMENT_GATEWAY_URL = `${API_URL}${EVENT_URL}${eventId}/payment-gateway`;
    const payload = {
        public_key: publicKey,
        secret_key: secretKey,
        pg_type: pgType
    };
    return axios.post(PAYMENT_GATEWAY_URL, payload);
};

export const disconnectPaymentGateway = (eventId, pgType) => {
    return axios.delete(`${API_URL}${EVENT_URL}${eventId}/payment-gateway`, {
        params: { pg_type: pgType }
    });
};

export const getPaymentGateways = (eventId) => {
    return axios.get(`${API_URL}${EVENT_URL}${eventId}/payment-gateway`);
};

export const validatePaymentGateway = (eventId, pgType, secretKey) => {
    return axios.get(`${API_URL}${EVENT_URL}${eventId}/payment-gateway/validate`, {
        params: {
            pg_type: pgType,
            secret_key: secretKey
        }
    });
};

export const updateStripeWebhook = (eventId) => {
    return axios.put(`${API_URL}${EVENT_URL}${eventId}/payment-gateway/stripe/webhooks`)

};
